import { RefObject, useCallback } from 'react';
import { useIntersectionObserver } from './use-intersection-observer';

/**
 * Вызов переданного события при попадании елемента во вью порт
 * @param {RefObject<HTMLElement[] | HTMLElement>}  refs
 * @param {(target: Element) => void} intersectCb
 */
export const useIntersection = (refs: RefObject<HTMLElement[] | HTMLElement>, intersectCb: (target: Element) => void) => {
  const intersectionObserverCallback = useCallback(
    (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
      entries.forEach(({ isIntersecting, target }: IntersectionObserverEntry) => {
        if (isIntersecting) {
          intersectCb(target);
          observer.unobserve(target);
        }
      });
    },
    [intersectCb]
  );

  useIntersectionObserver(refs, intersectionObserverCallback);
};
